interface ImportMetaEnv {
  VITE_API_URL: string
  VITE_SUPABASE_URL: string
  VITE_SUPABASE_ANON_KEY: string
  VITE_USER_DASHBOARD_URL: string
  VITE_MERCHANT_DASHBOARD_URL?: string
  // Optional timeout configuration for testing
  VITE_AUTH_TIMEOUT_MINUTES?: string
  VITE_AUTH_WARNING_SECONDS?: string
}

export const env = {
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
  VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
  VITE_USER_DASHBOARD_URL: import.meta.env.VITE_USER_DASHBOARD_URL,
  VITE_MERCHANT_DASHBOARD_URL: import.meta.env.VITE_MERCHANT_DASHBOARD_URL,
  VITE_AUTH_TIMEOUT_MINUTES: import.meta.env.VITE_AUTH_TIMEOUT_MINUTES,
  VITE_AUTH_WARNING_SECONDS: import.meta.env.VITE_AUTH_WARNING_SECONDS,
}

// Helper function to get timeout configurations
export const getAuthTimeoutConfig = () => {
  const timeoutMinutes = env.VITE_AUTH_TIMEOUT_MINUTES ? parseInt(env.VITE_AUTH_TIMEOUT_MINUTES, 10) : 30
  const warningSeconds = env.VITE_AUTH_WARNING_SECONDS ? parseInt(env.VITE_AUTH_WARNING_SECONDS, 10) : 60

  return {
    inactivityTimeoutMs: timeoutMinutes * 60 * 1000,
    warningTimeMs: warningSeconds * 1000,
    timeoutMinutes,
    warningSeconds
  }
}
